import angular from 'angular';

export class MetaModel {
    /**
     * @param {Object} defaults - pojo (deserialized version) of a MetaModel to initialize state. 
     */
    constructor(initializer, $sce) {
        let init = (initializer) ? angular.copy(initializer) : {};
        init.tcpa_consent_text = $sce.trustAsHtml(init.tcpa_consent_text);
        const defaults = {
            tcpa_compliant: false,
            tcpa_consent_text: null
        }
        angular.extend(this, defaults, init);
    }

    serialize() {
        if (!this.tcpa_consent_text) return {};
        let serialized = {
            tcpa_consent_text: this.tcpa_consent_text.$$unwrapTrustedValue(),
            tcpa_compliant: true
        }
        return serialized;        
    }
}

export class MetaService {
    constructor($sce) {
        this.$sce = $sce;
    }

    /**
     * create a new MetaModel instance.
     * @param {Object} defaults - pojo (deserialized version) of a MetaModel to initialize state. 
     */
    newModel(defaults) {
        return new MetaModel(defaults, this.$sce);
    }
}
MetaService.$inject = ['$sce']


// WEBPACK FOOTER //
// ./app/jangl/MetaService.js